import React from "react";
import BankAccountDetails from "./BankAccountDetails";
import {Formik} from "formik";
import GenericDialog from "../../dialog/GenericDialog";
import {Divider, Grid, Typography} from "@material-ui/core";
import {Button} from "../../formInputs";
import * as Yup from "yup";
import {useActions} from "../../../actions";
import * as PaymentActions from "../../../actions/payment";
import {usePolicyContext} from "./PolicyContext";
import {useSelector} from "react-redux";
import {RootState} from "../../../reducers";

const initialValues = {
    bankName: "",
    bankAccountHolder: "",
    routingNumber: "",
    accountNumber: "",
    confirmAccountNumber: "",
    checkFrontPath: "",
};

const BankAccountSchema = Yup.object().shape({
    bankName: Yup.string().required("Required"),
    bankAccountHolder: Yup.string().required("Required"),
    routingNumber: Yup.string().required("Required"),
    accountNumber: Yup.string().required("Required"),
    confirmAccountNumber: Yup.string()
        .oneOf([Yup.ref('accountNumber')], 'Account number must match').required("Required"),

});
const BankAccountForm = (props: any) => {
    const {policy, refetchPolicy}: any = usePolicyContext();
    const { user } = useSelector((state: RootState) => state.auth);
    const {handleClose} = props;
    const payment = useActions(PaymentActions);
    const saveBankAccountDetails = async (values: any, actions: any) => {
        const paymentMethodPayload = {
            policyNumber: policy.policyNumber,
            emailAddress: user.email,
            accountHolder: values.bankAccountHolder,
            bankName: values.bankName,
            accountType: 'PersonalChecking',
            routingNumber: values.routingNumber,
            accountNumber: values.accountNumber,
            // files: [values.checkFrontPath, values.checkBackPath] // NIWD-120
            files: [values.checkFrontPath]
        };
        const paymentMethod = await payment.addPaymentMethod(paymentMethodPayload);
        actions.setSubmitting(false);
        await refetchPolicy();
        actions.resetForm();
        handleClose();
    };

    return (
        <Formik initialValues={initialValues} onSubmit={saveBankAccountDetails} validationSchema={BankAccountSchema}>
            {({
                  handleSubmit,
                  isSubmitting
              }) =>
                (
                    <form onSubmit={handleSubmit}>
                        <Typography>
                            You can add additional bank accounts to choose from when making ePay contribution payments.
                            Please
                            enter
                            your bank information below.
                        </Typography>
                        <BankAccountDetails />
                        <Divider/>
                        <Grid item xs={12}>
                            <Button
                                label="Save Account"
                                className="floatRight mb20"
                                type="submit"
                                size="small"
                                variant="contained"
                                color="primary"
                                disabled={isSubmitting}
                                loading={isSubmitting}
                            />
                            <Button
                                label="Cancel"
                                className="floatRight mb20"
                                onClick={handleClose}
                                color="primary"
                                size="small"
                            />
                        </Grid>
                    </form>)
            }
        </Formik>);
}

function BankAccountNew(props: any) {
    const {isNewAccount, setIsNewAccount} = props;
    const handleClose = () => {
        setIsNewAccount(false);
    }
    return (
        <GenericDialog open={isNewAccount} title={"Add New Bank Account"} content={<BankAccountForm handleClose={handleClose}/>}
                       onClose={handleClose}/>
    );
}

export default BankAccountNew;